import React, { useState } from "react"

const ServiceFaq: React.FC = () => {

    // Accordion Active Index
    const [active, setActive] = useState<number>(1);

    const toggleAccordion = (index: number) => {
        setActive(active === index ? -1 : index);
    };

    const faqItems = [
        {
            id: 1,
            title: "01. Escuchamos tu visión",
            content:
                "Nos tomamos el tiempo para entender tus ideas, objetivos y dirección creativa. Cada proyecto comienza escuchando cuidadosamente tu visión para transformarla en algo auténtico y visualmente poderoso.",
        },
        {
            id: 2,
            title: "02. Producción personalizada",
            content:
                "Cada marca y cada historia son diferentes. Creamos producciones audiovisuales diseñadas específicamente para tus necesidades, combinando calidad cinematográfica, creatividad y narrativa estratégica.",
        },
        {
            id: 3,
            title: "03. Dirección creativa",
            content:
                "Desde el desarrollo de la idea hasta la entrega final, guiamos cada etapa del proceso de producción con visión artística y atención al detalle para que cada toma comunique algo con propósito.",
        },
        {
            id: 4,
            title: "04. Resultados con impacto",
            content:
                "Creamos contenido que conecta con las audiencias, fortalece la identidad de marca y deja una impresión duradera a través de visuales de alta calidad y storytelling significativo.",
        },
    ];


    return (
            <div className="service-process-wrap pt-120 pb-125">
                <div className="row mt-none-50 align-items-center">
                    {/* LEFT SIDE ACCORDION */}
                    <div className="col-lg-6 mt-50">
                        <h2 className="details-content-title mb-40">Service process</h2>

                        <div className="service_process_faq">
                            <div className="accordion">
                                {faqItems.map((item) => (
                                    <div className="accordion-item" key={item.id}>
                                        <div
                                            className={`accordion-button ${active === item.id ? "" : "collapsed"
                                                }`}
                                            role="button"
                                            onClick={() => toggleAccordion(item.id)}
                                        >
                                            {item.title}
                                        </div>

                                        <div
                                            className={`accordion-collapse collapse ${active === item.id ? "show" : ""
                                                }`}
                                        >
                                            <div className="accordion-body">
                                                <p className="m-0">{item.content}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE CLICKABLE LIST */}
                    <div className="col-lg-6 mt-50">
                        <ul className="content_layer_group list-unstyled">
                            {faqItems.map((item) => (
                                <li
                                    key={item.id}
                                    onClick={() => toggleAccordion(item.id)}
                                    className={active === item.id ? "active" : ""}
                                >
                                    <span>{item.title.replace(/^\d+\.\s/, "")}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
    )
}

export default ServiceFaq;